import PurchasePage from './index.vue';
import PurchaseTabs from './PurchaseTabs.vue';
import PurchaseSearchForm from './PurchaseSearchForm.vue';
import PurchaseTable from './PurchaseTable.vue';

export default PurchasePage;

export {
  PurchaseTabs,
  PurchaseSearchForm,
  PurchaseTable
};
